// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeader_wrapper__0moba","image":"PageHeader_image__kkeq8"};